import * as React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import useSelectedEntities from "./hooks/useSelectedEntities";
const Container = styled.div`
  display: flex;
  align-items: center;
`;
const SelectedEntitiesAmount = styled.div`
  margin-left: 5px;
`;
const BulkActionsRow = ({ bulkActions, className = void 0 }) => {
  const { t } = useTranslation("common");
  const { selectedEntities } = useSelectedEntities();
  return /* @__PURE__ */ React.createElement(Container, { className }, bulkActions, !!selectedEntities.length && /* @__PURE__ */ React.createElement(SelectedEntitiesAmount, null, t("entity_table.selected_items", { count: selectedEntities.length })));
};
export default BulkActionsRow;
